module.exports = __webpack_public_path__ + "img/43.c3ad4c9a.jpg";